import { CancelTokenSource } from 'axios';
import { StockDataDto, StockDataSearchRequest } from 'ts-types/api.types';
import axios from 'services/http';


const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/stock-data`;

export const getAllStockData = (
    source: CancelTokenSource): Promise<Array<StockDataDto>> => {

  return axios
      .get(apiUri, { cancelToken: source.token })
      .then(response => response.data);
};

export const searchStockData = (stockDataSearchRequest: Partial<StockDataSearchRequest>,
                                  source: CancelTokenSource): Promise<Array<StockDataDto>> => {

  return axios
      .post(`${apiUri}/search`, stockDataSearchRequest, {cancelToken: source.token})
      .then(response => response.data)

};
